import { useApi } from "@lending/lib/api";

function useCreateEligibilitySelectionQuery() {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/eligibility_selections/", {});
}

export { useCreateEligibilitySelectionQuery };
